<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">

				<tr *ngFor="let item of itemsToShow; let i = index">
					<td class="text-nowrap" style="max-width: 20ch;">
						{{ item.added_on | date: ac.tableDateTimeFmt }}
					</td>
					<!-- <td *ngIf="showUserInfo" class="text-nowrap">
						<fa-icon *ngIf="item['__authIcon']" [icon]="item['__authIcon']" [ngbTooltip]="item['__authMode']"></fa-icon>
						<span [ngbTooltip]="item.user_info">
							<a *ngIf="linkUser && item.added_by !== 0" [routerLink]="['/' + ac.urls.users, item.added_by]">
								{{ item['__usernameToShow'] }}
							</a>
							<span *ngIf="!linkUser || item.added_by === 0">
								{{ item['__usernameToShow'] }}
							</span>
						</span>
					</td> -->

					<td *ngIf="showUserInfo" class="cp-chopped-col-medium">
						<fa-icon *ngIf="item['__authIcon']" [icon]="item['__authIcon']" [ngbTooltip]="item['__authMode']"></fa-icon>
						<a *ngIf="linkUser && item.added_by!== 0" [routerLink]=" ['/' + ac.urls.users, item.added_by]"
							[ngbTooltip]="item['__username']">
							{{ item['__username'] }}
						</a>
						<span *ngIf="!linkUser || item.added_by === 0" [ngbTooltip]="item['__username']">
							{{ item['__username'] }}
						</span>
					</td>
					<td *ngIf="showObjectInfo" class="text-nowrap">
						{{ item['__niceType'] | titlecase }}
					</td>
					<td *ngIf="showObjectInfo" class="cp-chopped-col-medium">
						<span [ngbTooltip]="item.obj_name">
							<a *ngIf="linkObject && item.obj_id !== 0 && item.action !== 'delete' && item.action !== 'purge'"
								[hidden]="!expandNames" [routerLink]="item['__route']">
								{{ item.obj_name }}
							</a>
							<span *ngIf="!linkObject || item.obj_id === 0 || item.action === 'delete' || item.action === 'purge'"
								[hidden]="!expandNames">
								{{ item.obj_name }}
							</span>
							<a *ngIf="linkObject && item.obj_id !== 0 && item.action !== 'delete' && item.action !== 'purge'"
								[hidden]="expandNames" class="text-nowrap" [routerLink]="item['__route']">
								{{ item['__objNameToShow'] }}
							</a>
							<span *ngIf="!linkObject || item.obj_id === 0 || item.action === 'delete' || item.action === 'purge'"
								[hidden]="expandNames" class="text-nowrap">
								{{ item['__objNameToShow'] }}
							</span>
						</span>
					</td>
					<td class="text-nowrap">
						{{ item['__niceAction'] | titlecase }}
					</td>
					<td (click)="copyToClipboardAlert(item.information)">
						<div [ngbTooltip]="item.information" class="cp-chopped-col-long">
							<fa-icon *ngIf="item.information && item.information !== ''" [icon]="['fas', 'copy']" ngxClipboard
								[cbContent]="item.information" ngbTooltip="Copy to Clipboard"></fa-icon>
							{{ item.information }}
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>